<template>
  <div class="training-clazz-static-info-comp">
    <div class="title">
      <span> 班级统计 </span>

      <el-form v-if="clazzOptions" inline>
        <el-form-item>
          <cs-select :value="value" label="班级" @change="updateClazzId">
            <el-option v-for="(option, index) in clazzOptions" :key="index" :value="option.value" :label="option.label">
            </el-option>
          </cs-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="summary-box-comp">
      <div class="item" v-for="(info, index) in clazzSummaryItems" :key="index">
        <div class="title">{{ info.title }}</div>
        <div class="value" :style="getValueStyle(info)">
          {{ info.title === '完成率' ? formatRate(+info.value) : info.value }}{{ info.title === '完成率' ? '%' : '' }}
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Emit, Prop } from 'kuaidong-component'
import { NewCourseLiveService } from 'kuaidong-service'
import { UnitUtil } from 'kuaidong-lib'
import CsSelect from '@/components/CsSelect.vue'

@Component({
  components: { CsSelect },
})
export default class TrainingClazzStaticInfo extends BaseComponent {
  @Prop({ type: Number, required: false })
  value?: number

  @Prop({ type: Array, required: true })
  clazzSummaryItems!: {
    value: string
    title: string
  }[]

  @Prop({ type: Array })
  clazzOptions?: {
    value: number
    label: string
    challenge_id: string
    challenge_class_id: string
  }[]

  get service() {
    return NewCourseLiveService
  }

  getValueStyle(info: { value: number; title: string }) {
    if (info.title === '完成率') {
      return this.service.participatedRateColor(+info.value * 100)
    } else {
      return null
    }
  }

  formatRate(rate: number | undefined) {
    return typeof rate === 'number' ? UnitUtil.percent(rate / 100) : '-'
  }

  @Emit('change')
  updateClazzId(clazzIds: number[]) {
    return clazzIds[0]
  }
}
</script>
<style lang="less">
.training-clazz-static-info-comp {
  margin-top: 27px;

  > .title {
    font-weight: 500;
    font-size: 16px;
    line-height: 23px;
    color: #0a1629;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > .el-form {
      > .el-form-item {
        margin: 0;
      }
    }
  }

  > .summary-box-comp {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    > .item {
      width: 224px;
      text-align: left;

      > .value {
        margin-top: 6px;
        font-weight: 700;
        font-size: 24px;
        line-height: 26px;
        color: #2d2f33;
      }

      > .title {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #9da2a9;
      }
    }
  }
}
</style>
